import React, { useCallback, useState } from 'react'
import { TableRow, TableCell, IconButton, Input } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { palette } from 'styles/colors'
import editIcon from 'assets/edit.png'
import deleteIcon from 'assets/delete.png'
import Button from 'components/Button'
import { useHistory } from 'react-router-dom'
import { Check } from '@material-ui/icons'
import { useDispatch, useSelector } from 'react-redux'
import {
  changeCarouselNumber,
  getSpecialists
} from 'redux/modules/specialists/actions'
import { getSpecialistsPagination } from 'redux/selectors/specialists'
import config from 'api/config'

const ARCHIVED_ROW_BG = '#e8e8e8'

const Specialist = ({
  classes,
  specialist,
  editSpecialistsName,
  openDelete,
  openDeleteSignature,
  archiveSpecialist,
  goToReceptions,
  fetchSpecialists
}) => {
  const dispatch = useDispatch()

  const [number, setNumber] = useState(specialist.carouselNumber ?? 0)

  const specialistsPagination = useSelector(getSpecialistsPagination)

  const saveNumber = (specialist) => {
    dispatch(
      changeCarouselNumber(
        {
          carouselNumber: Number(number),
          specialistId: specialist.id
        },
        () => {
          fetchSpecialists(
            specialistsPagination.page,
            specialistsPagination.perPage
          )
        },
        (error) => {}
      )
    )
  }

  const downloadSign = (specialist) => {
    let a = document.createElement('a')
    a.href = `${config.axios.baseImgUrl}${specialist.signature}`
    a.download = `signature_${specialist.fullName}.png`
    a.target = '_blank'
    a.click()
  }

  const isArchived = Boolean(specialist.isArchived)
  const cellStyle = {
    borderColor: palette.black,
    ...(isArchived ? { backgroundColor: ARCHIVED_ROW_BG } : {})
  }

  return (
    <TableRow key={specialist.id} style={isArchived ? { backgroundColor: ARCHIVED_ROW_BG } : undefined}>
      <TableCell style={{ width: '130px', ...cellStyle }} align="center">
        {specialist.fullName}
        {isArchived && (
          <span style={{ display: 'block', fontSize: 12, color: '#757575', marginTop: 4 }}>
            В архиве
          </span>
        )}
      </TableCell>
      <TableCell style={{ width: '130px', ...cellStyle }} align="center">
        {specialist.isDuty
          ? 'Дежурный врач'
          : specialist.specialities && specialist.specialities.length > 0
          ? specialist.specialities.length > 1
            ? `${specialist.specialities[0].title} ...`
            : specialist.specialities[0].title
          : 'Не указана специальность'}
      </TableCell>
      <TableCell style={{ width: '130px', ...cellStyle }} align="center">
        <Button
          text={'Перейти к приемам'}
          onClick={() => goToReceptions(specialist)}
          otherStyles={{
            width: '200px',
            backgroundColor: palette.blueButton,
            color: palette.white,
            marginBottom: '1em',
            marginTop: '1em'
          }}
        />
      </TableCell>
      <TableCell style={{ width: '50px', ...cellStyle }} align="center">
        <Input
          onChange={(e) => setNumber(e.target.value)}
          value={number}
          style={{ width: 40 }}
        />
        <IconButton
          onClick={() => {
            saveNumber(specialist)
          }}
        >
          <Check />
        </IconButton>
      </TableCell>
      <TableCell style={{ width: '130px', ...cellStyle }} align="center">
        <Button
          text={'Скачать'}
          onClick={() => downloadSign(specialist)}
          otherStyles={{
            width: '100px',
            backgroundColor: specialist.signature
              ? palette.blueButton
              : palette.daysDisables,
            color: palette.white,
            marginBottom: '1em',
            marginTop: '1em'
          }}
          disabled={!specialist.signature}
        />
        <IconButton
          onClick={() => {
            openDeleteSignature(specialist)
          }}
          disabled={!specialist.signature}
        >
          <img src={deleteIcon} alt="delete" width="15" />
        </IconButton>
      </TableCell>
      <TableCell style={{ width: '40px', ...cellStyle }} align="center">
        <IconButton onClick={() => editSpecialistsName({ ...specialist })}>
          <img src={editIcon} alt="edit" width="15" />
        </IconButton>
      </TableCell>
      <TableCell style={{ width: '150px', ...cellStyle }} align="center">
        <Button
          text={isArchived ? 'Вернуть из архива' : 'В архив'}
          onClick={() => archiveSpecialist(specialist)}
          otherStyles={{
            width: '160px',
            backgroundColor: palette.blueButton,
            color: palette.white,
            marginBottom: '0.5em',
            marginTop: '0.5em',
            fontSize: 12
          }}
        />
      </TableCell>
      <TableCell style={{ width: '50px', ...cellStyle }} align="center">
        <IconButton
          onClick={() => {
            openDelete(specialist)
          }}
        >
          <img src={deleteIcon} alt="delete" width="15" />
        </IconButton>
      </TableCell>
    </TableRow>
  )
}

const Specialists = ({
  classes,
  specialists,
  editSpecialistsName,
  openDelete,
  openDeleteSignature,
  archiveSpecialist,
  fetchSpecialists
}) => {
  const router = useHistory()

  const goToReceptions = useCallback((specialist) => {
    router.push({ pathname: `/receptions`, state: { id: specialist.id } })
  }, [])

  return specialists.map((specialist) => (
    <Specialist
      key={specialist.id}
      goToReceptions={goToReceptions}
      specialist={specialist}
      openDelete={openDelete}
      editSpecialistsName={editSpecialistsName}
      openDeleteSignature={openDeleteSignature}
      archiveSpecialist={archiveSpecialist}
      fetchSpecialists={fetchSpecialists}
    />
  ))
}
const styles = () => ({})

export default withStyles(styles)(Specialists)
